import React from 'react';
import {View, StyleSheet} from 'react-native';
import Styles from '../../Styles';
import type {MenuCategoryType, MenuProductType} from 'src/types/Menu';
import {DNA} from 'src/types/dnaTypes';
import AVText from 'src/components/elements/AVText';
import {FlashList} from '@shopify/flash-list';
import {getDescriber} from 'src/components/elements/orderAhead/descriptor/DescriptorType';
import MenuItemListTemplate2 from 'src/components/elements/orderAhead/MenuListItemTemplate2';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const {getMenuListCompnentsFontFamily} = getDescriber();

type SubMenuProps = {
  menu: MenuCategoryType;
  dnaConfiguration?: DNA;
  onProductPress: (product: MenuProductType) => void;
};
export default function NewSubMenu({
  menu,
  dnaConfiguration,
  onProductPress,
}: SubMenuProps): JSX.Element {
  const renderItem = ({item, index}) => {
    return (
      <View style={styles.renderItemStyle}>
        <MenuItemListTemplate2
          dnaConfiguration={dnaConfiguration}
          onPress={() => onProductPress(item)}
          name={item.name || ''}
          item={item}
          price={parseFloat(item.price || '0')}
          imageUrl={item.smallimageurl ?? null}
          isProductCat={true}
          index={index}
          overrideDna={item.overrideDna || 'Nope'}
        />
      </View>
    );
  };

  return (
    <View style={styles.container} accessible>
      {menu?.products.length > 0 && (
        <>
          <View
            accessible
            accessibilityLabel={`submenu-${menu?.longname}`}
            style={styles.submenuLabelView}
          >
            <AVText
              style={styles.subMenuLabel}
              accessible
              accessibilityLabel={`${menu?.longname}`}
              aria-label={`${menu?.longname}, text`}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            >
              {menu?.longname}
            </AVText>
          </View>
          <FlashList
            data={menu?.products ?? []}
            renderItem={renderItem}
            keyExtractor={(item, index) => `${item.id || item.name}-${index}`}
            estimatedItemSize={72}
          />
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  subMenuLabel: {
    fontFamily: getMenuListCompnentsFontFamily(),
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    color: Styles.Colors.PayNew.black01,
    fontWeight: '700',
  },
  submenuLabelView: {
    marginBottom: Styles.Spacing.m3,
    marginHorizontal: Styles.Spacing.m3,
  },
  renderItemStyle: {flex: 1},
  container: {
    flex: 1,
    marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
});
